/**
 * Header de sitio: estado is-scrolled (logo → logo + nombre).
 */
(function () {
  'use strict';

  var header = document.querySelector('[data-edas-header]');
  if (!header) {
    return;
  }

  var scrollThreshold = 48;
  var ticking = false;

  function updateScrollState() {
    ticking = false;
    var scrolled = window.scrollY > scrollThreshold;
    header.classList.toggle('is-scrolled', scrolled);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateScrollState);
    }
  }

  updateScrollState();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
